import React from 'react';
import { BlockDataForm } from '@plone/volto/components';
import { useIntl } from 'react-intl';
import { MainImageSchema } from './schema';
import type { MainImageBlockData } from './index';

interface MainImageBlockDataProps {
  data: MainImageBlockData;
  block: string;
  onChangeBlock: (id: string, data: MainImageBlockData) => void;
  [key: string]: any;
}

const MainImageBlockDataForm: React.FC<MainImageBlockDataProps> = (props) => {
  const { data, block, onChangeBlock } = props;
  const intl = useIntl();
  const schema = MainImageSchema({ ...props, intl });

  const handleFieldChange = (id: string, value: any) => {
    onChangeBlock(block, {
      ...data,
      [id]: value,
    });
  };

  return (
    <BlockDataForm
      schema={schema}
      title={schema.title}
      onChangeField={handleFieldChange}
      formData={data}
      block={block}
    />
  );
};

export default MainImageBlockDataForm;
